/**
 * Required fields (brief sections 2, 3 and 6). Defined here once, in code, and
 * used by the web app and the API alike. They are not configuration.
 */

/** A contact needs these four fields; everything else is optional. */
export const CONTACT_REQUIRED_FIELDS = ['first_name', 'last_name', 'email', 'company'] as const;

/**
 * Creating a lead needs these four answers (Discovery, decision of Nov 2,
 * 2026): the person's role in the project, the applications (WR-1 to WR-4),
 * the installation country and the pain. Without them the person stays a
 * contact. Interest is no longer asked: not knowing yet means a contact.
 */
export const LEAD_CREATION_REQUIRED_FIELDS = [
  'role',
  'applications',
  'installation_country',
  'pain',
] as const;
export type LeadCreationField = (typeof LEAD_CREATION_REQUIRED_FIELDS)[number];

/** Interface labels of the four answers, used in validation messages. */
export const LEAD_CREATION_LABELS: Record<LeadCreationField, string> = {
  role: 'Role in the project',
  applications: 'Applications',
  installation_country: 'Installation country',
  pain: 'Pain',
};

export const CONTACT_FORM_FIELDS = [
  'first_name',
  'last_name',
  'email',
  'company',
  'job_title',
  'mobile',
  'office_phone',
  'linkedin_url',
  'country',
  'applications',
  'interest',
  'role',
  'pain',
  'wants_content',
  'note',
] as const;
export type ContactFormField = (typeof CONTACT_FORM_FIELDS)[number];

/** Interface labels, used in validation messages. */
export const FIELD_LABELS: Record<ContactFormField, string> = {
  first_name: 'First name',
  last_name: 'Last name',
  email: 'Email',
  company: 'Company',
  job_title: 'Job title',
  mobile: 'Mobile',
  office_phone: 'Office phone',
  linkedin_url: 'LinkedIn',
  country: 'Country',
  applications: 'Applications',
  interest: 'Interest',
  role: 'Role',
  pain: 'Pain',
  wants_content: 'Send brochure and video',
  note: 'Note',
};
